import { urls } from "../constants/app";
import { setError } from "./errors";
import request from "./utils/request";

export function setBlockedOrdersCount(data) {
    return (dispatch) => {
        dispatch({ type: 'SET_BLOCKEDORDERS_COUNT', data: data});
    }
}

export function setBlockedOrdersList(data) {
    return (dispatch) => {
        dispatch({ type: 'SET_BLOCKEDORDERS_LIST', data: data});
    }
}

export function setBlockedOrdersFilters(filters) {
    return dispatch => {
        dispatch({ type: 'SET_BLOCKEDORDERS_FILTERS', filters });
    }
}

export function setBlockedOrdersPaging(paging) {
    return dispatch => {
        dispatch({ type: 'SET_BLOCKEDORDERS_PAGING', paging });
    }
}

export function fetchBlockedOrders() {
    return async (dispatch, getState) => {
        dispatch({ type: 'SET_LOADER', field: 'blockedOrders', value: true });
        const filials = getState().handbook.filials;
        const filters = getState().blockedOrders.filters;
        const paging = getState().blockedOrders.paging;
        const user = getState().user.info;

        const params = {}

        if (filters.point) {
            params['point'] = filters.point.value;
        } else if (filials.length > 0) {
            params['point_in'] = filials.map(filial => filial.id);
        } else if (user.points.length > 0) {
            const pointIds = user.points.map(item => item.id);
            params['point_in'] = pointIds
        }

        if (filters.id) params['id'] = filters.id;
        if (filters.phone) params['phone'] = filters.id;

        params['_sort'] = `id:desc`;
        params['_start'] = paging.start;
        params['_limit'] = paging.limit;
        
        try {
            const count = await request({ method: 'get', url: `${urls.blockedOrders}/count` });
            dispatch(setBlockedOrdersCount(count))
            const blockedOrders = await request({ method: 'get', url: urls.blockedOrders, params });
            dispatch(setBlockedOrdersList(blockedOrders));
            dispatch({ type: 'SET_LOADER', field: 'blockedOrders', value: false });
        } catch(error) {
            dispatch(setError(error, 'blockedOrders'));
            dispatch({ type: 'SET_LOADER', field: 'blockedOrders', value: false });
        }
    }
}